import * as XLSX from 'xlsx'

/**
 * Export a formatted array into CSV.
 */
export const exportToCsv = (data, fileName) => {
  const sheet = data.map(item => item.join(';')).join('\n')
  const link = document.createElement('a')
  const blob = new Blob([`\uFEFF${sheet}`], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  link.href = url
  link.setAttribute('download', `${fileName}.csv`)
  link.click()
}
/**
 * Export a formatted array into xlsx.
 */
export const exportToExcel = (data, fileName) => {
  // Create sheet from data
  const worksheet = XLSX.utils.json_to_sheet(data)

  // Create a work book and add a sheet
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  // Generate excel file and create a download link
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}.xlsx`)
  document.body.appendChild(link)
  link.click()

  // delete temporal link
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
